import {dialogApi} from '../../../../../api/dialogApi'
import {cx} from '../../../../../utils/classNameUtil'
import {
  WuButton,
  WuCard,
  WuCardHeader,
  WuHeading,
  WuIcon,
} from '@npm-questionpro/wick-ui-lib'
import styles from './SummaryCard.module.scss'
import {useState, useRef, useEffect} from 'react'
import {useParams} from 'react-router'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../../Translation/English/dialog'

export const SummaryCard: React.FC = () => {
  const wt = useWt()
  const [isExpanded, setIsExpanded] = useState(false)
  const [showSeeMore, setShowSeeMore] = useState(false)
  const summaryRef = useRef<HTMLDivElement>(null)
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: analyticsData} = dialogApi.useDialogAnalytics(dialogId ?? '')
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '')
  const dialogAnalyticsDateTime = analyticsData?.generatedAt

  const getTodaysDate = (): string => {
    const today = dialogAnalyticsDateTime
      ? new Date(dialogAnalyticsDateTime)
      : new Date()
    const month = today.toLocaleString('en-US', {month: 'short'})
    const day = today.getDate()
    const year = today.getFullYear()
    return `${month} ${day}, ${year}`
  }

  useEffect(() => {
    if (summaryRef.current) {
      const element = summaryRef.current
      setShowSeeMore(element.scrollHeight > element.clientHeight)
    }
  }, [analyticsData])

  return (
    <>
      <WuCard rounded>
        <WuCardHeader className={styles.heading}>
          <div className={styles.title}>
            <WuHeading size="sm">{wt(DIALOG.summary)}</WuHeading>
            <WuIcon icon="wc-ai" className={styles.aiIcon} />
          </div>
        </WuCardHeader>
        <div className={styles.container}>
          <div className={styles.details}>
            <div>
              {wt(DIALOG.generatedOn)} {getTodaysDate()}
            </div>
            <div>
              {dialogDetails?.totalResponsesCount} {wt(DIALOG.responses)}{' '}
            </div>
          </div>
          <div
            ref={summaryRef}
            className={cx(
              styles.summary,
              isExpanded ? styles.expanded : styles.collapsed,
            )}
          >
            {analyticsData?.summary}
          </div>
          {showSeeMore && (
            <WuButton
              variant="link"
              className={styles.seeMore}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? wt(DIALOG.seeLess) : wt(DIALOG.seeMore)}
            </WuButton>
          )}
        </div>
      </WuCard>
    </>
  )
}
